var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_426_3187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1694 3.04001C15.5701 3.30466 14.9349 3.47889 14.2844 3.55701C14.9694 3.1463 15.4821 2.50105 15.7274 1.74101C15.0827 2.1226 14.3775 2.39146 13.6424 2.53601C13.3355 2.20819 12.9644 1.94703 12.5522 1.7688C12.14 1.59057 11.6955 1.49908 11.2464 1.50001C10.7516 1.49961 10.2632 1.61111 9.81761 1.82618C9.37203 2.04124 8.98086 2.35429 8.67336 2.7419C8.36587 3.12951 8.15002 3.58165 8.04197 4.06447C7.93392 4.54729 7.93646 5.0483 8.04941 5.53001C6.74445 5.4643 5.46785 5.12519 4.3023 4.53467C3.13675 3.94414 2.10825 3.11536 1.28341 2.10201C0.990572 2.60243 0.83725 3.17221 0.83941 3.75201C0.83941 4.89201 1.41941 5.89501 2.29941 6.48401C1.77819 6.46757 1.26841 6.32701 0.81241 6.07401V6.11401C0.81241 7.70401 1.94241 9.03201 3.44541 9.33401C2.96187 9.46363 2.45535 9.48277 1.96341 9.39001C2.17321 10.0423 2.58161 10.6127 3.13151 11.0215C3.68142 11.4303 4.34533 11.6571 5.03041 11.67C3.86723 12.5818 2.43138 13.0763 0.95341 13.074C0.68841 13.074 0.42741 13.059 0.17041 13.029C1.67172 13.9927 3.41844 14.5043 5.20241 14.503C11.2404 14.503 14.5424 9.50301 14.5424 5.16501C14.5424 5.02201 14.5384 4.88101 14.5324 4.74001C15.1751 4.27524 15.7298 3.69956 16.1704 3.04001H16.1694Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_3187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.17041)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.7374f6a128d1f88d6ba057cb7ffdcffc.svg";
export { ForwardRef as ReactComponent };